import React from "react";
import { Dialog } from "@material-ui/core";
import InvoicesPrint from "../../../../Reviews/Invs/AFReadyDisigen/InvoicesPrint";
import InvoiceCashirPrint from "../../../../Reviews/Invs/CasherReadyDisigen/InvoiceCashirPrint";
export default function InvoiceTypePrintA4(props) {
    const {
        openPrint,
        handNewInv,
        keepFocus,
        isFocus,
        foundData,setFoundData
    } = props;
    const typeInv = openPrint.invType;
    const locInv = openPrint.localInv;
    return (
        <Dialog
            fullScreen
            open={openPrint.open}
            onClose={() =>handNewInv()}
        >
            {openPrint.invKind === 2 ?
                <InvoicesPrint  {...{ typeInv, locInv, handNewInv,keepFocus ,isFocus,foundData,setFoundData}} /> :
                <InvoiceCashirPrint {...{ typeInv, locInv, handNewInv ,keepFocus,isFocus,foundData,setFoundData}} />}
        </Dialog>

    );
}
